import React, { useState } from 'react';

const DirectoryContext = React.createContext({
  isOpenModal: false,
  updateOpenModal: () => {},
  isAddMode: true,
  updateAddMode: () => {},
  editData: {},
  updateEditData: () => {},
});

export const DirectoryContextProvider = ({ children }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isAddMode, setIsAddMode] = useState(true);
  const [editData, setEditData] = useState({});

  return (
    <DirectoryContext.Provider
      value={{
        isOpenModal,
        updateOpenModal: setIsOpenModal,
        isAddMode,
        updateAddMode: setIsAddMode,
        editData,
        updateEditData: setEditData,
      }}
    >
      {children}
    </DirectoryContext.Provider>
  );
};

export default DirectoryContext;
